import { Chart } from 'chart.js';

Chart.scaleService.registerScaleType(
  'timecenter',
  Chart.scaleService.getScaleConstructor('time').extend({
    getPixelForTick(index) {
      const ticks = this.getTicks();
      // Get the pixel value for the current tick.
      const px = this.getPixelForOffset(ticks[index].value);
      // Get the next tick's pixel value.
      let nextPx = this.right;
      const nextTick = ticks[index + 1];
      if (nextTick) nextPx = this.getPixelForOffset(nextTick.value);
      // Align the labels in the middle of the current and next tick.
      return px + (nextPx - px) / 2;
    },
  }),
  Chart.scaleService.getScaleDefaults('time'),
);



// WEBPACK FOOTER //
// ./src/components/common/Charts/extensions/timecenter.js